import { isString } from 'lodash-es'

export type ResponseTransformer = (data: any, headers?: Headers) => any

export interface ClientRequestInit extends RequestInit {
	baseUrl?: string
	transformResponse?: ResponseTransformer | ResponseTransformer[]
	params?: Record<string, string> | string
	body?: RequestInit['body'] | any
}

function isFormData(value: unknown): value is FormData {
	if (typeof FormData === 'undefined') {
		return false
	}
	return value instanceof FormData
}

export function client(endpoint: string, requestInit?: ClientRequestInit) {
	const {
		baseUrl,
		params,
		body,
		headers: requestHeaders,
		transformResponse,
		...requestConfig
	} = requestInit ?? {}
	const headers = {
		// 'content-type': 'application/json'
	}

	const config: RequestInit = {
		method: body ? 'POST' : 'GET',
		...requestConfig,
		headers: {
			...headers,
			...requestHeaders,
		},
		body: body
			? isString(body)
				? body
				: isFormData(body)
					? body
					: JSON.stringify(body)
			: undefined,
	}

	const url = baseUrl ? `${baseUrl}${endpoint}` : endpoint
	const searchParams = params
		? isString(params)
			? `?${params}`
			: `?${new URLSearchParams(params)}`
		: ''

	return window.fetch(url + searchParams, config).then(async (response) => {
		if (response.ok) {
			const res = await getExistingJson(response)

			if (!transformResponse) {
				return res
			}

			if (Array.isArray(transformResponse)) {
				return transformResponse.reduce((acc, t) => t(acc), res)
			}

			return transformResponse(res)
		}

		const errorMessage = await response.text()

		const error = new Error(
			errorMessage || `${response.statusText} (${response.status})`,
		) as Error & { status: number }
		error.status = response.status
		throw error
	})
}

export function createClientInstance(instanceRequestInit: ClientRequestInit) {
	return (endpoint: string, requestInit?: ClientRequestInit) =>
		client(endpoint, { ...instanceRequestInit, ...requestInit })
}

async function getExistingJson(response: Response) {
	try {
		return await response.json()
	} catch (_e) {
		return null
	}
}

export type Client = typeof client
